import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingTextComponent } from '@freelancer/components/loading-text';
import { LoadingTemplateComponent } from '@freelancer/ui/loading-template';

@Component({
  selector: 'fl-challenge-card-default-loading',
  standalone: true,
  imports: [LoadingTemplateComponent, LoadingTextComponent],
  template: `
    <fl-loading-template class="Cover"></fl-loading-template>
    <div class="Body">
      <fl-loading-text [rows]="2"></fl-loading-text>
      <fl-loading-text [rows]="3"></fl-loading-text>
    </div>
  `,
  styleUrls: ['./challenge-card-default-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeCardDefaultLoadingComponent {}
